import type { Configuration } from '@azure/msal-browser';

import { config } from '../config.js';

export const msalConfig: Configuration = {
  auth: {
    clientId: config.entraClientId,
    authority: `https://login.microsoftonline.com/${config.entraTenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: null,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

// Sign-in request for the unified SPA client. Requests the Workflow API's
// delegated scope up front so the first authenticated API call resolves from
// the token cache instead of triggering a second interactive prompt.
export const loginRequest = {
  scopes: [
    'openid',
    'profile',
    `api://${config.workflowApiServiceAppId}/access_as_user`,
  ],
};

// Bearer-token request for the Workflow API.
export const apiRequest = {
  scopes: [`api://${config.workflowApiServiceAppId}/access_as_user`],
};

// Bearer-token request for Microsoft Graph profile access.
export const graphRequest = {
  scopes: ['User.Read', 'User.ReadBasic.All'],
};

// Bearer-token request for the DataLake service API.
export const datalakeApiRequest = {
  authority: `https://login.microsoftonline.com/${config.datalakeTenantId}`,
  scopes: [`${config.datalakeServiceAppId}/.default`],
};
